import { cn } from "@repo/utils";

export default function ProjetMiseEnPlaceTeletravail() {
  return (
    <div className={cn("flex flex-col items-center")}>
      <div className={cn("font-bold")}>N°8</div>
      <img
        src="/logos/sytel_grand_est.png"
        alt="logo_sytel_grand_est"
        height={200}
        width={200}
      />
      <div className={cn("font-bold underline")}>ANNEXE</div>
      <div className={cn("font-bold")}>
        Projet de mise en place du télétravail
      </div>
      <div className={cn("space-y-4 px-4")}>
        <div className={cn("font-bold underline")}>
          Définition du télétravail :
        </div>
        <div>
          Le télétravail désigne toute forme d&apos;organisation du travail dans
          laquelle un travail qui aurait également pu être exécuté dans les
          locaux de l&apos;employeur, est effectué par un salarié hors de ces
          locaux de façon volontaire en utilisant les technologies de
          l&apos;information et de la communication.
        </div>
        <div>
          Le télétravailleur est le salarié de l&apos;entreprise qui effectue,
          soit dès l&apos;embauche, soit ultérieurement, du télétravail tel que
          défini ci-dessus.
        </div>
        <div>
          Nota bene : Bien que le télétravail a été mis en exergue depuis la
          crise sanitaire liée à la COVID-19, il a été initié par un accord
          cadre européen du 16 juillet 2002 qui a ensuite été transposé par
          l&apos;accord national interprofessionnel du 19 juillet 2005. Le
          législateur a ensuite étendu cet ANI et créé dans le code du travail
          des dispositions spécifiques au télétravail dans la loi n°2012-387 du
          22 mars 2012.
        </div>
        <div className={cn("font-bold underline")}>
          Caractéristiques du télétravail :
        </div>
        <div>
          <ul className={cn("list-disc pl-12")}>
            <li>
              Le télétravail ne peut être mis en œuvre que sur la base du
              volontariat.
            </li>
          </ul>
          <div>
            Au service administratif, nous sommes tous volontaires pour tester
            cette organisation et vous proposons de vous adresser des écrits
            pour formaliser nos demandes!
          </div>
        </div>
        <div>
          <ul className={cn("list-disc pl-12")}>
            <li>
              L&apos;entreprise peut définir des critères d&apos;éligibilité
              pour accéder au télétravail en fonction de l&apos; emploi, de
              l&apos;âge, de l&apos;ancienneté, des besoins des services, etc.
            </li>
          </ul>
          <div>
            Au service administratif, la présence consécutive de toute
            l&apos;équipe n&apos;est pas nécessaire pour assurer la continuité
            de l&apos;activité et ne pas désorganiser le service. Pour rappel,
            notre équipe est composée de 2 agents de maîtrise, 6 employés et 2
            analystes programmeurs. Nos activités peuvent se faire à distance !
          </div>
        </div>
        <div>
          <ul className={cn("list-disc pl-12")}>
            <li>
              Les équipements à domicile doivent être suffisants pour permettre
              le télétravail (accès internet, accès aux serveurs, à la GED, aux
              logiciels, etc.) et à défaut mis à disposition par
              l&apos;employeur.
            </li>
          </ul>
          <div>
            Tous les salariés du service administratif sont équipés d&apos;accès
            internet à leur domicile leur permettant d&apos; accéder aux
            serveurs et logiciels de l&apos;entreprise.
          </div>
        </div>
        <div>
          <ul className={cn("list-disc pl-12")}>
            <li>
              La prise en charge par les assurances des dommages causés par le
              télétravailleur à domicile.
            </li>
          </ul>
          <div>
            Sur ce point, il faudrait contacter l&apos;assurance de
            l&apos;entreprise pour qu&apos;elle puisse définir clairement ce qui
            ne relèverait pas de son périmètre. Le cas échéant, nous nous
            adresserons à nos assurances respectives afin d&apos; étendre nos
            garanties pour permettre le télétravail à domicile.
          </div>
        </div>
      </div>

      <div className={cn("space-y-4 px-4")}>
        <ul className={cn("list-disc pl-12")}>
          <li>
            Décompte du temps de travail : ce point est à définir en interne et
            nous vous proposons des auto-déclarations.{" "}
          </li>
        </ul>
        <div className={cn("font-bold underline")}>
          Modalités de mise en place :
        </div>
        <div>
          <div>
            Pour permettre l&apos;expérimentation du télétravail,
            l&apos;employeur a deux possibilités :
          </div>
          <ul className={cn("list-disc pl-12")}>
            <li>
              la signature d&apos;un accord d&apos;entreprise avec les instances
              représentatives du personnel
            </li>
            <li>
              à défaut, la mise en place d&apos;une charte sur le télétravail
              pour laquelle le Comité Social et Economique aura été consulté en
              amont.
            </li>
          </ul>
        </div>
        <div>
          Nous sommes prêts à travailler avec vous pour vous proposer un projet
          d&apos;accord ou de charte reprenant les différentes modalités de mise
          en place du télétravail.{" "}
        </div>
        <div className={cn("font-bold underline")}>
          Proposition de l&apos;organisation :
        </div>
        <div>
          Nous pourrions garder le lundi en présentiel afin de permettre la
          réunion d&apos;équipe et la transmission d&apos; information avec les
          collègues des différents services.
        </div>
        <div>
          Du mardi au vendredi, nous vous proposons que la moitié de
          l&apos;équipe soit en présentiel, et l&apos;autre moitié en
          télétravail :
        </div>
        <table>
          <thead className={cn("border-b-2 border-gray-600")}>
            <th className={cn("w-80 border-collapse border border-gray-600")}>
              En présentiel sur site
            </th>
            <th className={cn("w-80 border-collapse border border-gray-600")}>
              En télétravail
            </th>
          </thead>
          <tbody>
            <tr>
              <td className={cn("border-x border-gray-600 px-2")}>
                1 agent de maîtrise
              </td>
              <td className={cn("border-x border-gray-600 px-2")}>
                1 agent de maîtrise
              </td>
            </tr>
            <tr>
              <td className={cn("border-x border-gray-600 px-2")}>3 employés</td>
              <td className={cn("border-x border-gray-600 px-2")}>3 employés</td>
            </tr>
            <tr className={cn("border-b border-gray-600")}>
              <td className={cn("border-x border-gray-600 px-2")}>
                1 analyste programmeur{" "}
              </td>
              <td className={cn("border-x border-gray-600 px-2")}>
                1 analyste programmeur{" "}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

ProjetMiseEnPlaceTeletravail.title = "Projet de mise en place du télétravail";
